import { BaseApiService } from "../base/base-api.service";

import { ListSortDirection, Sort } from "../../models/api/sort";

import { SaveResponse } from "../../models/api/save/save.response";
import { DocumentTypeReportExclutionSTO } from "../../models/documents/documents-reports/document-type-report-exclusion-sto ";
import { DocumentTypeReportExclutionDTO } from "../../models/documents/documents-reports/document-type-report-exclusion-dto ";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";

export class DocumentTypeReportExclusionApiService extends BaseApiService<
  DocumentTypeReportExclutionDTO,
  DocumentTypeReportExclutionSTO
> {
  constructor() {
    super({
      servicePath: "/AuditTypeReports",
      loadItemsPath: "/GetReportDocumentTypeExclutions",
      saveItemsPath: "/SaveReportDocumentTypesExclution",
    });
    this.defaultSort = [
      {
        name: "documentType.name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const saveDocumentTypeReportExclusion = async (
  documentTypeReportExclusion: DocumentTypeReportExclutionSTO
): Promise<SaveResponse> => {
  const apiService = new DocumentTypeReportExclusionApiService();
  const response = await apiService.saveItems([documentTypeReportExclusion]);

  toastifyResponse(response, "all", "default_success_message", "failure_saving_data", "error_saving_data");

  return response;
};
